<app-google-one-tap></app-google-one-tap>
<router-outlet></router-outlet>
<app-dialogs></app-dialogs>
<!-- e2e test doesn't like it when this is loaded later-->
@defer (on idle) {
<app-tooltip-global></app-tooltip-global>
<app-toasts></app-toasts>
<app-mobile-menus></app-mobile-menus>
<app-context-menu-global></app-context-menu-global>
<app-route-loader [active]="routeLoading"></app-route-loader>
} @error {} @defer (when showCookieBanner) { @if (showCookieBanner) {
<app-cookie-banner (onHide)="hideCookieBanner()"></app-cookie-banner>
} } @error {} @defer (when showServerTiming) { @if (showServerTiming) {
<app-server-timing></app-server-timing>
} } @error {} @defer (when state.recordDebug) { @if (state.recordDebug) {
<button
  appButton
  name="record-debug"
  location="app"
  shape="round"
  color="orange"
  weight="bold"
  height="1"
  size="1"
  [hasIcon]="true"
  class="record-debug"
  (click)="downloadDebugFile()"
>
  <app-svg src="/assets/icons/bug.svg"></app-svg>
  <span>Download</span>
</button>
} } @error {}
